@import "../config/_helpers";
.slider {
	width: 100%;
	.slider-wrapper {
		position: relative;
		height: 100%;
		.slider-arrow-container {
			position: absolute;
			width: 100%;
			z-index: 2;
			user-select: none;
			pointer-events: none;
			.slider-arrow {
				font-size: 18px;
				cursor: pointer;
				background: white;
				border-radius: 50%;
				aspect-ratio: 1/1;
				width: 40px;
				display: flex;
				align-items: center;
				justify-content: center;
				margin: 10px;
				box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
				user-select: none;
				pointer-events: all;
				&:hover {
					cursor: pointer;
				}
			}
		}
		&.draggable {
			.slider-container {
				// transition: unset;
			}
		}
		.slider-container {
			flex: 1 1 100%;
			overflow: hidden;
			height: 100%;

			&.lightbox-active {
				@include at-breakpoint($m) {
					.slider-item {
						&:hover img {
							transform: scale(3);
						}
						img {
							position: relative;
							left: 0;
							// transition: .2s transform ease-in-out;
						}
					}
				}
			}

			.slider-track {
				position: relative;
				left: 0;
				height: 100%;
				transition: left 0.4s ease-in-out;
				--gap: 0;
				scroll-snap-type: x mandatory;

				--slides-per-row: var(--slides-per-row-base, 1);
				@include at-breakpoint($m) {
					--slides-per-row: var(--slides-per-row-md, var(--slides-per-row-base, 1));
				}
				@include at-breakpoint($l) {
					--slides-per-row: var(--slides-per-row-lg, var(--slides-per-row-md, var(--slides-per-row-base, 1)));
				}

				.slider-item {
					user-select: none;
					flex: 0 0 calc(100% / var(--slides-per-row));
					width: calc(100% / var(--slides-per-row));
					// overflow: hidden;
					padding: 0 5px;
					height: 100%;
					scroll-snap-align: start end;
					// transition: .4s all ease-in-out;
					// transition-delay: .4s;
					.slider-item__img {
						object-fit: cover;
						border-radius: 5px;
					}
					.slider-item__text {
						padding: 10px;
						font-weight: bold;
						background: white;
						border-radius: 0 0 5px 5px;
						.btn {
							margin-top: 15px;
							background: transparent;
							color: #222;
							border: 1px solid #222;
							cursor: pointer;
							&:hover {
								color: white;
								background: #222;
							}
						}
					}
				}
			}
		}
	}
	.slider-indicators-container {
		gap: 5px;
		margin-top: 20px;
		.slider-indicator {
			height: 8px;
			width: 8px;
			border-radius: 50%;
			background: rgba(0, 0, 0, 0.2);
			transition: 0.4s all ease-in-out;
			&:not(.active):hover {
				cursor: pointer;
				transform: scale(1.05);
				background: rgba(0, 0, 0, 0.1);
			}
			&.active {
				background: rgba(0, 0, 0, 0.6);
				transform: scale(1.1);
			}
		}
		.slider-indicator-preview {
			width: 75px;
			height: 75px;
			background: none !important;
			border-radius: 5px;
			overflow: hidden;
			transform: scale(1) !important;
			img {
				height: 100%;
				object-fit: cover;
			}
		}

		&.slider-indicators-preview-container {
			justify-content: flex-start;
		}
	}

	&.lightbox {
		.slider-item {
			overflow: hidden;
		}
	}

	.slider-wrapper.draggable {
		cursor: grab;
		.slider-container {
			margin: 0 -15px;
			padding: 0 15px;
			.slider-track {
				// transition: none;
			}
		}
	}

	&.fade {
		.slider-wrapper {
			.slider-container {
				.slider-track {
					transition: 0s left;
					.slider-item {
						opacity: 0;
						transition: 0.4s opacity ease-in-out;
						&.active {
							opacity: 1;
						}
					}
				}
			}
		}
	}

	&.fade {
		.slider-wrapper {
			.slider-container {
				.slider-track {
					transition: 0s left;
					left: unset !important;
					.slider-item {
						opacity: 0;
						transition: all 1s ease-in-out;
						position: absolute;
						inset: 0;
						align-items: center;
						align-content: center;
						justify-content: center;
						&.active {
							opacity: 1;
							z-index: 2;
						}
					}
				}
			}
		}
	}

	.slider-instructions {
		position: absolute;
		bottom: 0;
		padding: 10px;
		width: 100%;
		z-index: 3;
		background: rgba(0, 0, 0, 0.6);
		display: flex;
		border-radius: 5px;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		color: white;
		pointer-events: none;
		opacity: 0;
		transition: 0.4s all ease-in-out;
		.slider-instructions-icon {
			font-size: 24px;
			border-bottom: 1px solid white;
			svg {
				animation: fingerScroll 1.5s infinite;
				// display: block;
				@keyframes fingerScroll {
					0% {
						transform: rotateZ(0);
					}
					25% {
						transform: rotateZ(-10deg);
					}
					75% {
						transform: rotateZ(30deg);
					}
					100% {
						transform: rotateZ(0);
					}
				}
			}
		}
		&.visible {
			pointer-events: all;
			opacity: 1;
		}
	}
}
